import cn from 'classnames';
import React from 'react';

/* eslint-disable react/prop-types */
function TimeGridEvent(props) {
  const {
    style,
    className,
    event,
    accessors,
    isRtl,
    selected,
    label,
    continuesEarlier,
    continuesLater,
    getters,
    onClick,
    onDoubleClick
  } = props;
  let title = event.title;
  let tooltip = event.tooltip;
  let end = event.end;
  let start = event.start;

  // let userProps = getters.eventProp(event, start, end, selected)

  let { height, top, width, xOffset } = style;
  const inner = [
    <div key="1" className="rbc-event-label">
      {label}
    </div>
  ];

  return (
    <div
      style={{
        top: `${top}%`,
        height: `${height}%`,
        [isRtl ? 'right' : 'left']: `${Math.max(0, xOffset)}%`,
        width: `${width}%`
      }}
      title={
        tooltip
          ? (typeof label === 'string' ? label + ': ' : '') + tooltip
          : undefined
      }
      className={cn('rbc-event', className, {
        'rbc-selected': selected,
        'rbc-event-continues-earlier': continuesEarlier,
        'rbc-event-continues-later': continuesLater
      })}
    >
      {inner}
    </div>
  );
}

export default TimeGridEvent;
